import { InjectionToken } from '@angular/core';
import { AuthConfig } from '@nebula-shared/domain';

export const AUTH_CONFIG_TOKEN = new InjectionToken<AuthConfig>('AUTH_CONFIG_TOKEN');
export const API_BASE_URL_TOKEN = new InjectionToken<string>('API_BASE_URL_TOKEN');
